var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import Manager from '../modal/Manager';
//@ts-ignore
import { Overlay as ReactOverlay } from 'react-overlays';
import { appColors } from '@styled/useTheme';
import { OverlayTooltip as StyledOverlayTooltip } from '@styled/Basic';
var TOOLTIP_STYLE = {
    position: 'absolute',
    padding: '0 5px',
    zIndex: 99999,
};
var TOOLTIP_ARROW_STYLE = {
    position: 'absolute',
    width: 0,
    height: 0,
    borderColor: 'transparent',
    borderStyle: 'solid',
};
function getTooltipInnerStyle(backgroundColor, borderColor, color, padding, radius, shadow) {
    return {
        padding: padding,
        textAlign: 'center',
        borderRadius: radius || 2,
        backgroundColor: backgroundColor,
        border: '1px solid',
        borderColor: borderColor,
        color: color,
        boxShadow: shadow || '2px 2px 2px #aaa',
        maxWidth: '650px',
    };
}
function placementStyles(color) {
    return {
        left: {
            tooltip: { marginLeft: -3, padding: '0 5px' },
            arrow: { right: 0, top: '50%', marginTop: -5, borderWidth: '5px 0 5px 5px', borderLeftColor: color },
        },
        right: {
            tooltip: { marginRight: 3, padding: '0 5px' },
            arrow: { left: 0, top: '50%', marginTop: -5, borderWidth: '5px 5px 5px 0', borderRightColor: color },
        },
        top: {
            tooltip: { marginTop: -3, padding: '5px 0' },
            arrow: { left: '50%', bottom: 0, marginLeft: -5, borderWidth: '5px 5px 0', borderTopColor: color },
        },
        bottom: {
            tooltip: { marginBottom: 3, padding: '5px 0' },
            arrow: { left: '50%', top: 0, marginLeft: -5, borderWidth: '0 5px 5px', borderBottomColor: color },
        },
    };
}
function getColor(type) {
    switch (type) {
        case 'light':
            return { bgColor: '#fff', borderColor: '#ccc', color: '#000', padding: 'none' };
        case 'info':
            return { bgColor: '#f7f7f7', borderColor: '#666', color: '#333', padding: '5px 8px' }; //$main-brand-4: bg color
        case 'dark':
            // TODO:
            return { bgColor: '#f7f7f7', borderColor: '#666', color: '#333', padding: '5px 8px' };
        //return {bgColor: 'rgba(60,67,85,90)', borderColor: 'rgba(60,67,85,90)', color: '#fff', padding: '5px 8px'};
        case 'transparent':
            return { bgColor: 'rgba(255, 255, 255, 100)', borderColor: 'rgba(255, 255, 255, 100)', color: '#fff' };
        case 'white':
        default:
            return {
                bgColor: '#fff',
                borderColor: '#fff',
                color: appColors.ui.dark,
                padding: '4px 8px',
                radius: 4,
                shadow: '0px 0px 15px 0px #00000050',
            };
    }
}
var OverlayTooltip = function (props) {
    var _a = getColor(props.type), bgColor = _a.bgColor, borderColor = _a.borderColor, color = _a.color, padding = _a.padding, radius = _a.radius, shadow = _a.shadow;
    var placementStyle = placementStyles(borderColor)[props.placement];
    var style = props.style, children = props.children, innerRef = props.innerRef;
    return (React.createElement(StyledOverlayTooltip, { ref: innerRef, style: __assign(__assign(__assign({}, TOOLTIP_STYLE), placementStyle.tooltip), style) },
        React.createElement("div", { style: __assign(__assign({}, TOOLTIP_ARROW_STYLE), placementStyle.arrow) }),
        React.createElement("div", { style: getTooltipInnerStyle(bgColor, borderColor, color, padding, radius, shadow) }, children)));
};
var Overlay = function (_a) {
    var rootClose = _a.rootClose, placement = _a.placement, targetNode = _a.targetNode, type = _a.type, children = _a.children;
    var _b = __read(useState(true), 2), show = _b[0], setShow = _b[1];
    function close() {
        setShow(false);
        if (Manager && Manager.closePopover) {
            Manager.closePopover();
        }
    }
    return (React.createElement(ReactOverlay, { show: show, rootClose: rootClose, onHide: close, placement: placement, target: targetNode }, function (_a) {
        var props = _a.props, placement = _a.placement;
        return (React.createElement(OverlayTooltip, { type: type || 'white', style: props.style, innerRef: props.ref, placement: placement }, children));
    }));
};
export default Overlay;
